let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ux6f")).then(() => parcelRequire('7JZ4r'));